export const apiConfig = {
    apiUrl: process.env.REACT_APP_API_URL as string,
    apiClientId: process.env.REACT_APP_API_CLIENT_ID as string,
    apiClientSecret: process.env.REACT_APP_API_CLIENT_SECRET as string,
    liveApiUrl: process.env.REACT_APP_LIVE_API_URL as string,
}